define([
    'lodash',
    'localSiteSerializer/plugins/styles',
    'localSiteSerializer/plugins/commonComponents',
    'localSiteSerializer/plugins/pages',
    'localSiteSerializer/plugins/siteInfo',
    'localSiteSerializer/plugins/routers',
    'localSiteSerializer/plugins/background',
    'localSiteSerializer/plugins/menu',
    'localSiteSerializer/plugins/layout'
], function (_, styles, commonComponents, pages, siteInfo, routers, background, menu, layout) {
    'use strict';
    // the order is important (commonComponents should be after styles)
    return {
        styles,
        layout,
        pages,
        menu,
        background,
        commonComponents,
        routers,
        siteInfo
    };
});